"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientDataProvider = exports.EntityType = exports.PropertyConditionType = void 0;
var PropertyConditionType;
(function (PropertyConditionType) {
    PropertyConditionType["EntityPropertyExists"] = "entityPropertyExists";
    PropertyConditionType["EntityPropertyEqualTo"] = "entityPropertyEqualTo";
    PropertyConditionType["EntityPropertyContainsAny"] = "entityPropertyContainsAny";
    PropertyConditionType["EntityPropertyContainsAll"] = "entityPropertyContainsAll";
})(PropertyConditionType = exports.PropertyConditionType || (exports.PropertyConditionType = {}));
var EntityType;
(function (EntityType) {
    EntityType["Space"] = "space";
    EntityType["Content"] = "content";
})(EntityType = exports.EntityType || (exports.EntityType = {}));
var ClientDataProvider = (function () {
    function ClientDataProvider() {
        var _this = this;
        this.globalFetchPromise = new Promise(function (resolve, reject) {
            _this.globalFetchResolve = resolve;
            _this.globalFetchReject = reject;
        });
        this.propertyValueRequests = [];
    }
    ClientDataProvider.prototype.fetchPropertyValues = function (propValueRequests) {
        var _a;
        (_a = this.propertyValueRequests).push.apply(_a, propValueRequests);
        return this.globalFetchPromise;
    };
    ClientDataProvider.prototype.resolve = function (clientData) {
        var _a;
        (_a = this.globalFetchResolve) === null || _a === void 0 ? void 0 : _a.call(this, clientData);
    };
    ClientDataProvider.prototype.reject = function (reason) {
        var _a;
        (_a = this.globalFetchReject) === null || _a === void 0 ? void 0 : _a.call(this, reason);
    };
    return ClientDataProvider;
}());
exports.ClientDataProvider = ClientDataProvider;
